<template>
	<Body class="page-instashop" />
	<BasePublishCategory v-slot="{item: category}" :seo="true">
		<BasePublishPosts :fetch="{extra_data: ['images']}" v-slot="{items, nextPage, loadMore, loading}">
			<div class="instashop-header-container">
				<div class="wider-wrapper">
					<CmsBreadcrumbs v-if="category?.breadcrumbs" :items="category.breadcrumbs" />
					<h1 v-if="category?.seo_h1">{{category.seo_h1}}</h1>
				</div>
			</div>

			<div class="instashop-main">
				<div class="wider-wrapper instashop-wrapper">
					<div v-if="items?.length">
						<div class="instashop-items" :id="'items_'+category?.code">
							<PublishIndexEntryInstashop :items="items" />
						</div>

						<div class="load-more-container" v-if="nextPage">
							<UiLoader v-if="loading" />
							<button v-else type="button" class="btn btn-primary load-more-instashop" @click="loadMore"><BaseCmsLabel code="load_more" tag="span" /></button>
						</div>
						<BaseUiPagination class="pagination" />
					</div>
					<div v-else class="empty-instashop"><BaseCmsLabel code="no_publish" /></div>
				</div>
			</div>
		</BasePublishPosts>
	</BasePublishCategory>

	<PublishInstashopModal :instashopData="instashopData" />
</template>

<script setup>
	const instashopData = useState('instashopData');
</script>


<style lang="less" scoped>
	.instashop-wrapper{
		width: 1680px;
		@media (max-width: 1700px){width: 1400px;}
		@media (max-width: @l){width: 1250px;}
		@media (max-width: @t){width: auto;}
	}
	.empty-instashop{
		padding: 20px 0 50px; text-align: center;
		@media (max-width: @tp){padding: 10px 0;}
	}

	.instashop-main{
		padding-bottom: 104px;
		@media (max-width: @t){padding-bottom: 70px;}
		@media (max-width: @tp){padding-bottom: 40px;}
	}
	.instashop-header-container{
		display: flex; justify-content: center; text-align: center; border-top: 1px solid var(--borderColor); padding: 41px 0 32px;
		@media (max-width: @t){padding: 30px 0 22px;}
		@media (max-width: @tp){padding: 24px 0 16px;}
	}
	h1{font-weight: bold;}
	.instashop-items{
		display: flex; flex-wrap: wrap; gap: 21px;
		@media (max-width: @t){gap: 15px;}
		@media (max-width: @tp){gap: 8px;}
	}

	.load-more-container{display: flex; flex-flow: column;}
	.load-more-instashop{
		margin: 48px auto 0;
		@media (max-width: @t){margin-top: 32px;}
		@media (max-width: @tp){margin-top: 24px;}
	}
</style>